import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CampaignCustomTerm } from '../../../../models/campaign';

@Component({
  selector: 'campaign-custom-term-details',
  templateUrl: './campaign-custom-term-details.component.html',
  styleUrls: ['./campaign-custom-term-details.component.scss']
})
export class CampaignCustomTermDetailsComponent implements OnInit {

  @Input() term: CampaignCustomTerm;
  @Output()
  addEvent = new EventEmitter<any>();
  @Output()
  editEvent = new EventEmitter<any>();
  @Output()
  backEvent = new EventEmitter<any>();

  public isCreate: boolean;

  constructor() { }

  ngOnInit() {
    if (!this.term) {
      this.term = new CampaignCustomTerm();
      this.isCreate = true;
    } else {
      this.isCreate = false;
    }
  }

  public add(term: CampaignCustomTerm) {
    this.addEvent.emit(term);
  }

  public edit(term: CampaignCustomTerm) {
    this.editEvent.emit(term);
  }

  public back() {
    this.backEvent.emit();
  }

}



// WEBPACK FOOTER //
// ./src/app/main/campaigns-add/campaign-custom-term-details/campaign-custom-term-details.component.ts